import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import * as types from './CommonActionType';
import * as actions from './CommonActions';
import * as commonService from './CommonServices';
import { convertStreamToBlob, getMimeType, downloadBlobUrl } from '../../../utils/fileDownloads';
import SweetAlert from '../../../components/sweetalert/SweetAlert';
import { getNavigate } from '../../../utils/history';

function* fetchRolesSaga(action) {
    try {
        const response = yield call(commonService.getRoles, action.payload);
        yield put(actions.getRolesSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getRolesFailure(error));
    }
}

function* fetchStatusSaga(action) {
    try {
        const response = yield call(commonService.getStatus, action.payload);
        yield put(actions.getStatusSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getStatusFailure(error));
    }
}

function* fetchDocumentModulesSaga(action) {
    try {
        const response = yield call(commonService.getDocumentModules, action.payload);
        yield put(actions.getDocumentModulesSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getDocumentModulesFailure(error));
    }
}

function* fetchDocumentTypesWithConfigurationSaga(action) {
    try {
        const response = yield call(commonService.getDocumentTypesWithConfiguration, action.payload);
        yield put(actions.getDocumentTypesWithConfigurationSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getDocumentTypesWithConfigurationFailure(error));
    }
}

function* fetchStorageTypesSaga(action) {
    try {
        const response = yield call(commonService.getStorageTypes, action.payload);
        yield put(actions.getStorageTypesSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getStorageTypesFailure(error));
    }
}

function* fetchCommunicationTypesSaga(action) {
    try {
        const response = yield call(commonService.getCommunicationTypes, action.payload);
        yield put(actions.getCommunicationTypesSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getCommunicationTypesFailure(error));
    }
}
    // Classification dropdown saga
    function* fetchClassificationSaga(action) {
        try {
            const response = yield call(commonService.getDocumentTypesByModuleId, action.payload);
            yield put(actions.getClassificationSuccess(response.data?.items || []));
        } catch (error) {
            yield put(actions.getClassificationFailure(error));
        }
    }

function* fetchPriorityTypesSaga(action) {
    try {
        const response = yield call(commonService.getPriorityTypes, action.payload);
        yield put(actions.getPriorityTypesSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getPriorityTypesFailure(error));
    }
}

function* fetchRecipientGroupSaga(action) {
    try {
        const response = yield call(commonService.getRecipientGroup, action.payload);
        yield put(actions.getRecipientGroupSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getRecipientGroupFailure(error));
    }
}

function* fetchUsersForDDSaga(action) {
    try {
        const response = yield call(commonService.getUsers, action.payload);
        yield put(actions.getUsersForDDSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getUsersForDDFailure(error));
    }
}

function* fetchInvestorsForDDSaga(action) {
    try {
        const response = yield call(commonService.getInvestors, action.payload);
        yield put(actions.getInvestorsForDDSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getInvestorsForDDFailure(error));
    }
}

function* fetchEquityTypeClassSaga(action) {
    try {
        const equityTypeId = action.payload;
        const response = yield call(commonService.getEquityTypeClassByEquityTypeId, equityTypeId);
        yield put(actions.getEquityTypeClassSuccess({ equityTypeId, data: response.data?.items || [] }));
    } catch (error) {
        yield put(actions.getEquityTypeClassFailure(error));
    }
}

function* fetchDocumentDownloadSaga(action) {
    try {
        const { file, data, isDownload } = action.payload;
        const response = yield call(commonService.documentDownload, data);

        // Get the correct MIME type based on file type or file extension
        const fileType = file.type || (file.name && file.name.split('.').pop());
        const mimeType = getMimeType(fileType);
        const blob = yield call(convertStreamToBlob, response, mimeType);

        if (isDownload) {
            // Download functionality - use utility function
            yield call(downloadBlobUrl, blob, file.name);
            yield put(actions.documentDownloadSuccess(null));
        } else {
            // View functionality - store blob URL in state
            const result = {
                ...file,
                url: blob
            }
            yield put(actions.documentDownloadSuccess(result));
        }
    } catch (error) {
        console.error('Download error:', error);
        yield put(actions.documentDownloadFailure(error));
    }
}
function* fetchHoldcoUser(action) {
    try {
        const response = yield call(commonService.getHoldCoUsers, action.payload);
        yield put(actions.getHoldCoSuccess(response.data));
    } catch (error) {
        yield put(actions.getHoldCoFailure(error));
    }
}

function* fetchStatusByTypeSaga(action) {
    try {
        const type = action.payload;
        const response = yield call(commonService.getStatusByTypeForDropdown, type);
        yield put(actions.getStatusByTypeSuccess({ type, data: response.data?.items || [] }));
    } catch (error) {
        yield put(actions.getStatusByTypeFailure(error));
    }
}
function* fetchUserDetails() {
    try {
        const response = yield call(commonService.getUserDetails);
        yield put(actions.getUserDetailsSuccess(response.data));
    } catch (error) {
        yield put(actions.getUserDetailsFailure(error));
    }
}

// Save Contact Us
function* saveContactUs(action) {
    try {
        const response = yield call(commonService.saveContactUs, action.payload);
        // API returns HTTP 200 with status=false when the save fails - don't treat that as success
        if (!response?.status) {
            yield put(actions.saveContactUsFailure(response?.responseMessage));
            yield call(() => SweetAlert.error({
                title: 'Submission Failed',
                text: 'We could not submit your request. Please try again later.'
            }));
            return;
        }
        // responseMessage tells the user whether the email went out (or is disabled by EmailSettings)
        yield put(actions.saveContactUsSuccess({ data: response.data, message: response.responseMessage }));
    } catch (error) {
        yield put(actions.saveContactUsFailure(error));
        yield call(() => SweetAlert.error({
            title: 'Submission Failed',
            text: 'We could not submit your request. Please try again later.'
        }));
    }
}

function* saveDataUploadCenterSaga(action) {
    try {
        const response = yield call(commonService.saveDataUploadCenter, action.payload);

        if (response.status || response.data) {
            yield put(actions.saveDataUploadCenterSuccess(response.data));

            // Show success message
            yield call(() =>
                SweetAlert.success({
                    title: 'Success!',
                    text: 'Data uploaded successfully',
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    confirmButtonColor: '#28a745',
                }));

            const navigate = getNavigate();
            navigate(-1);
        } else {
            yield put(actions.saveDataUploadCenterFailure(response.responseMessage || 'Upload failed'));
        }
    } catch (error) {
        yield put(actions.saveDataUploadCenterFailure(error));
    }
}

function* deleteNotificationFileSaga(action) {
    try {
        const response = yield call(commonService.deleteNotificationFile, action.payload);
        yield put(actions.deleteNotificationFileSuccess(response.data));
    } catch (error) {
        yield put(actions.deleteNotificationFileFailure(error));
    }
}

// Fetch Category For Dropdown
function* fetchCategoryForDropdownSaga(action) {
    try {
        const response = yield call(commonService.getCategoryForDropdown, action.payload);
        yield put(actions.getCategoryForDropdownSuccess(response.data?.items || []));
    }
    catch (error) {
        yield put(actions.getCategoryForDropdownFailure(error));
    }
}

export default function* watchCommonSaga() {
    yield takeLatest(types.GET_ROLES_REQUEST, fetchRolesSaga);
    yield takeLatest(types.GET_STATUS_REQUEST, fetchStatusSaga);
    yield takeLatest(types.GET_DOCUMENT_MODULES_REQUEST, fetchDocumentModulesSaga);
    yield takeLatest(types.GET_DOCUMENT_TYPES_WITH_CONFIGURATION_REQUEST, fetchDocumentTypesWithConfigurationSaga);
    yield takeLatest(types.GET_STORAGE_TYPES_REQUEST, fetchStorageTypesSaga);
    yield takeLatest(types.GET_COMMUNICATION_TYPES_REQUEST, fetchCommunicationTypesSaga);
    yield takeLatest(types.GET_PRIORITY_TYPES_REQUEST, fetchPriorityTypesSaga);
    yield takeLatest(types.GET_RECIPIENT_GROUP_REQUEST, fetchRecipientGroupSaga);
    yield takeLatest(types.GET_USERS_FOR_DD_REQUEST, fetchUsersForDDSaga);
    yield takeLatest(types.GET_INVESTORS_FOR_DD_REQUEST, fetchInvestorsForDDSaga);
    yield takeEvery(types.GET_EQUITY_TYPE_CLASS_REQUEST, fetchEquityTypeClassSaga);
    yield takeLatest(types.DOCUMENT_DOWNLOAD_REQUEST, fetchDocumentDownloadSaga);
    yield takeLatest(types.GET_HOLDCO_USER_REQUEST, fetchHoldcoUser);
    yield takeLatest(types.GET_STATUS_BY_TYPE_REQUEST, fetchStatusByTypeSaga);
    yield takeLatest(types.GET_HOLDCO_USER_REQUEST, fetchHoldcoUser);
    yield takeLatest(types.GET_USER_DETAILS_REQUEST, fetchUserDetails);
    yield takeLatest(types.SAVE_CONTACT_US_REQUEST, saveContactUs);
    yield takeLatest(types.SAVE_DATA_UPLOAD_CENTER_REQUEST, saveDataUploadCenterSaga);
    yield takeLatest(types.DELETE_NOTIFICATION_FILE_REQUEST, deleteNotificationFileSaga);
    yield takeLatest(types.GET_CATEGORY_FOR_DROPDOWN_REQUEST, fetchCategoryForDropdownSaga);
    yield takeLatest(types.GET_CLASSIFICATION_REQUEST, fetchClassificationSaga);
}